/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_MenuInputs */

const en_help_menu = /** @type {(inputs: Help_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help menu`)
};

const fr_help_menu = /** @type {(inputs: Help_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu aide`)
};

const de_help_menu = /** @type {(inputs: Help_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilfemenü`)
};

const it_help_menu = /** @type {(inputs: Help_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu di aiuto`)
};

const ru_help_menu = /** @type {(inputs: Help_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`меню справки`)
};

const es_help_menu = /** @type {(inputs: Help_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú de ayuda`)
};

const zh_cn2_help_menu = /** @type {(inputs: Help_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帮助菜单`)
};

const ja_help_menu = /** @type {(inputs: Help_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘルプメニュー`)
};

const hi_help_menu = /** @type {(inputs: Help_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सहायता मेनू`)
};

const pt_pt2_help_menu = /** @type {(inputs: Help_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu de ajuda`)
};

/**
* | output |
* | --- |
* | "Help menu" |
*
* @param {Help_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const help_menu = /** @type {((inputs?: Help_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_menu(inputs)
	if (locale === "de") return de_help_menu(inputs)
	if (locale === "it") return it_help_menu(inputs)
	if (locale === "ru") return ru_help_menu(inputs)
	if (locale === "es") return es_help_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_help_menu(inputs)
	if (locale === "ja") return ja_help_menu(inputs)
	if (locale === "hi") return hi_help_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_help_menu(inputs)
	return en_help_menu(inputs)
});